import React from 'react';
import { motion } from 'framer-motion';

interface EventCardSectionProps {
  showContent: boolean;
}

const EventCardSection: React.FC<EventCardSectionProps> = ({ showContent }) => {
  if (!showContent) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="relative w-full max-w-[430px] mx-auto"
    >
      <div className="relative w-full">
        <img
          src="/images/opening-card.jpeg"
          alt="ALAM Alumni Homecoming 2025"
          className="w-full h-auto object-cover"
          style={{ display: 'block' }}
        />
      </div>
    </motion.div>
  );
};

export default EventCardSection;

